import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";

import UnitLibrary from "./routes/UnitLibrary";
import LELibrary from "./routes/LELibrary";

export default store => ({
  path: "school-library",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "school-library" */ "./components"),
      import(/* webpackChunkName: "school-library" */ "./modules/Module"),
    ]).then(([importedModule0, importedModule1]) => {
      const component = importedModule0.default;
      const reducer = importedModule1.default;

      injectReducer(store, {
        key: "schoolLibrary",
        reducer,
      });

      return component;
    })
  ),
  childRoutes: [UnitLibrary(store), LELibrary(store)],
});
